import {
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { TokenInterceptor } from '../app/interceptors/token-interceptor';
import { PerformanceInterceptor } from '../app/interceptors/performance-interceptor';
import { AuthUnauthorizedInterceptor } from '../app/interceptors/auth-unauthorized.interceptor';
import { SpinnerService } from './services/spinner.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(), 
      withInterceptors([
        TokenInterceptor,
        PerformanceInterceptor,
        AuthUnauthorizedInterceptor,
      ])
    ),
    MessageService,
    SpinnerService,

    {
      provide: LOCALE_ID,
      useValue: 'pt',
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },
  ],
};
